import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNonOptOutIndicator = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 29,
	height: 28,
	viewBox: "0 0 29 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9 0H21C25.4183 0 29 3.58172 29 8V20L19.4 10L9 0Z",
		fill: "#2171C6"
	})
});
export default SvgNonOptOutIndicator;
